/**
 * --------------------------------------------------------------------------
 * CoreUI PRO data-grid engine/scheduler.ts
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

export interface Scheduler {
  schedule: () => void
  dispose: () => void
}

export const createScheduler = (flush: () => void): Scheduler => {
  let scheduled = false
  let disposed = false

  const run = () => {
    scheduled = false
    if (!disposed) {
      flush()
    }
  }

  return {
    schedule() {
      if (scheduled || disposed) {
        return
      }

      scheduled = true
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(run)
        return
      }

      setTimeout(run, 16)
    },
    dispose() {
      disposed = true
    }
  }
}
